(function() {
  'use strict';

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    setupReveal();
    setupHero();
    if (!reduce) setupParallax();
    setupFaq();
    setupPhoneMask();
    scrollToSuccess();
  }

  // ===== Reveal =====
  function setupReveal() {
    const els = document.querySelectorAll('.bmc-rv');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(el => el.classList.add('in'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(el => io.observe(el));
  }

  // ===== Hero (anima palavras) =====
  function setupHero() {
    const hero = document.querySelector('.bmc-hero');
    if (!hero) return;
    requestAnimationFrame(() => setTimeout(() => hero.classList.add('in'), 100));
  }

  // ===== Parallax do hero =====
  function setupParallax() {
    const layers = document.querySelectorAll('[data-parallax]');
    if (!layers.length) return;
    let ticking = false;
    function update() {
      layers.forEach(layer => {
        const scene = layer.closest('[data-parallax-scene]');
        if (!scene) return;
        const rect = scene.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        const offset = (rect.top / window.innerHeight) * 60;
        layer.style.transform = `translateY(${offset}px)`;
      });
      ticking = false;
    }
    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  // ===== FAQ acordeão =====
  function setupFaq() {
    const list = document.querySelector('[data-faq-list]');
    if (!list) return;
    list.querySelectorAll('[data-faq-toggle]').forEach(btn => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.bmc-faq-item');
        const answer = item.querySelector('.bmc-faq-a');
        const isOpen = btn.getAttribute('aria-expanded') === 'true';

        list.querySelectorAll('[data-faq-toggle]').forEach(other => {
          if (other !== btn) {
            other.setAttribute('aria-expanded', 'false');
            other.closest('.bmc-faq-item').querySelector('.bmc-faq-a').style.maxHeight = null;
          }
        });

        if (isOpen) {
          btn.setAttribute('aria-expanded', 'false');
          answer.style.maxHeight = null;
        } else {
          btn.setAttribute('aria-expanded', 'true');
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      });
    });
  }

  // ===== Máscara de telefone =====
  function setupPhoneMask() {
    const phone = document.getElementById('bmc-phone');
    if (!phone) return;
    phone.addEventListener('input', () => {
      let v = phone.value.replace(/\D/g, '').slice(0, 11);
      if (v.length > 6) phone.value = `(${v.slice(0,2)}) ${v.slice(2,7)}-${v.slice(7)}`;
      else if (v.length > 2) phone.value = `(${v.slice(0,2)}) ${v.slice(2)}`;
      else if (v.length > 0) phone.value = `(${v}`;
    });
  }

  // ===== Rola até sucesso =====
  function scrollToSuccess() {
    const success = document.querySelector('[data-contact-success]');
    if (success) success.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();